module.exports = __webpack_public_path__ + "img/[发财].36a7983d.svg";